// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__328oU","inner":"Form_inner__3SNTS","range":"Form_range__1TxZC","name":"Form_name__1_Pjx","actions":"Form_actions__2M3kn"};